<div class="main-page">
    <div class="main-section">
        <div class="container">
            <div class="info">
                <p>Collect RedCoin and exchange them for rewards.</p>
                <img src="assets/images/cards/wallet-assets.svg" alt="" />
            </div>
        </div>
    </div>
    <div class="wallet-container">
        <div class="hicoin-tab">
            <div class="tab-header" (click)="tabClick()" >
                <p>How does <span style="color:#ff4e4e;">Hi</span><span style="color: #ff4e4e;">Coin</span> work?</p>
                <p *ngIf="!showTabContent">+</p>
                <p *ngIf="showTabContent">-</p>
            </div>
            <div class="tab-content" *ngIf="showTabContent">
                <p>The Terms and Conditions of each eGift will explain where it can be redeemed.</p>
            </div>
        </div>
        <div class="wallet">
            <img src="assets/images/icons/wallet-icon.svg" />
            <p>Your wallet balance:</p>
            <p>HC500</p>
        </div>
        <div class="charge-wallet">
            <p class="form-header">
                Charge your wallet
            </p>
            <div class="form">
                <div class="select-gateway">
                    <div class="radio-button">
                        <label for="bitpay" (click)="selectShipping('bitpay')">
                            <input type="radio" id="bitpay" name="shipping" value="bitpay" required >
                            <span></span>
                            <img src="assets/images/icons/bitpay-wallet.svg" />
                            <p>Fee : 3%</p>
                        </label>
                    </div>
                    <div class="radio-button" (click)="selectShipping('paypal')">
                        <label for="paypal">
                            <input type="radio" id="paypal" name="shipping"  value="paypal" >
                            <span></span>
                            <img src="assets/images/icons/paypal-wallet.svg" />
                            <p>Fee : 4%</p>
                        </label>
                    </div>
                    <div class="radio-button" (click)="selectShipping('masterCard')">
                        <label for="masterCard">
                            <input type="radio" id="masterCard" name="shipping"  value="masterCard">
                            <span></span>
                            <img src="assets/images/icons/master-card-wallet.svg" />
                            <p>Fee : 3%</p>
                        </label>
                    </div>
                    <div class="radio-button" (click)="selectShipping('redeem')">
                        <label for="redeem">
                            <input type="radio" id="redeem" name="shipping"  value="redeem">
                            <span></span>
                            <p class="redeem">Redeem</p>
                            <p>Fee : 3%</p>
                        </label>
                    </div>
                </div>
                <form [formGroup]="selectRewardForm" (ngSubmit)="onSubmit()">
                <!-- bitpay options -->
                <div class="select-options"  *ngIf="selectedTab == 'bitpay'">
                    <div class="header">
                        <img src="assets/images/icons/bitpay-wallet.svg" />
                        <p>Rewards </p>
                        <span></span>
                    </div>
                    <div class="options">
                        <div class="option">
                            <label for="bit500">
                                <input type="radio" name="selectedReward" id="bit500" value="bit500" formControlName="selectedReward" required>
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>b$500 <span class="price">= HC1000</span></p>
                            </label>
                        </div>
                        <div class="option">
                            <label for="bit700">
                                <input type="radio" name="selectedReward" id="bit700" value="bit700" formControlName="selectedReward">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>b$700 <span class="price">= HC2000</span></p>
                            </label>
                        </div>
                        <div class="option">
                            <label for="bit600">
                                <input type="radio" name="selectedReward" id="bit600" value="bit600" formControlName="selectedReward">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>b$600 <span class="price">= HC3000</span></p>
                            </label>
                        </div>
                        <div class="option">
                            <label for="bit800">
                                <input type="radio" name="selectedReward" id="bit800" value="bit800" formControlName="selectedReward">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>b$800 <span class="price">= HC4000</span></p>
                            </label>
                        </div>
                    </div>
                </div>
                <!-- paypal options -->
                <div class="select-options"  *ngIf="selectedTab == 'paypal'">
                    <div class="header">
                        <img src="assets/images/icons/paypal-wallet.svg" />
                        <p>Rewards </p>
                        <span></span>
                    </div>
                    <div class="options">
                        <div class="option">
                            <label for="paypal500">
                                <input type="radio" name="option" id="paypal500" value="paypal500">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>p$500 <span class="price">= HC1000</span></p>
                            </label>
                        </div>
                        <div class="option">
                            <label for="paypal700">
                                <input type="radio" name="option" id="paypal700" value="paypal700">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>p$700 <span class="price">= HC2000</span></p>
                            </label>
                        </div>
                        <div class="option">
                            <label for="paypal600">
                                <input type="radio" name="option" id="paypal600" value="paypal600">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>p$600 <span class="price">= HC3000</span></p>
                            </label>
                        </div>
                        <div class="option">
                            <label for="paypal800">
                                <input type="radio" name="option" id="paypal800" value="paypal800">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>p$800 <span class="price">= HC4000</span></p>
                            </label>
                        </div>
                    </div>
                </div>
                <!-- mastercard options -->
                <div class="select-options" *ngIf="selectedTab == 'masterCard'" >
                    <div class="header">
                        <img src="assets/images/icons/master-card-wallet.svg" />
                        <p>Rewards </p>
                        <span></span>
                    </div>
                    <div class="options">
                        <div class="option">
                            <label for="masterCard500">
                                <input type="radio" name="option" id="masterCard500" value="masterCard500">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>m$500 <span class="price">= HC1000</span></p>
                            </label>
                        </div>
                        <div class="option">
                            <label for="masterCard700">
                                <input type="radio" name="option" id="masterCard700" value="masterCard700">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>m$700 <span class="price">= HC2000</span></p>
                            </label>
                        </div>
                        <div class="option">
                            <label for="masterCard600">
                                <input type="radio" name="option" id="masterCard600" value="masterCard600">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>m$600 <span class="price">= HC3000</span></p>
                            </label>
                        </div>
                        <div class="option">
                            <label for="masterCard800">
                                <input type="radio" name="option" id="masterCard800" value="masterCard800">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>m$800 <span class="price">= HC4000</span></p>
                            </label>
                        </div>
                    </div>
                </div>
                <!-- redeem options -->
                <div class="select-options"  *ngIf="selectedTab == 'redeem'" >
                    <div class="header">
                        <p class="redeem">Redeem</p>
                        <p>Rewards </p>
                        <span></span>
                    </div>
                    <div class="options">
                        <div class="option">
                            <label for="redeem500">
                                <input type="radio" name="option" id="redeem500" value="redeem500">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>r$500 <span class="price">= HC1000</span></p>
                            </label>
                        </div>
                        <div class="option">
                            <label for="redeem700">
                                <input type="radio" name="option" id="redeem700" value="redeem700">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>r$700 <span class="price">= HC2000</span></p>
                            </label>
                        </div>
                        <div class="option">
                            <label for="redeem600">
                                <input type="radio" name="option" id="redeem600" value="redeem600">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>r$600 <span class="price">= HC3000</span></p>
                            </label>
                        </div>
                        <div class="option">
                            <label for="redeem800">
                                <input type="radio" name="option" id="redeem800" value="redeem800">
                                <span class="selector"></span>
                                <img src="assets/images/icons/coin.svg" />
                                <p>r$800 <span class="price">= HC4000</span></p>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="submit-button" *ngIf="selectedTab">
                    <button type="submit">Pay</button>
                </div>
            </form>
        </div>
            <div class="form-footer">
                <p>Need help?</p>
                <a [routerLink]="['/pages','contact-us']">Contact us</a>
            </div>
        </div>
    </div>
</div>

